"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx, Fragment } from 'react/jsx-runtime';
import clsx from 'clsx';
import { useIsTextTruncated } from '../../helpers/hooks/useIsTextTruncated.mjs';
import { useRef } from 'react';
import { Tooltip } from '../Tooltip/index.mjs';

function Truncate({
  children,
  endLetters = 5,
  className,
  id,
  placement,
  offset,
  usePortal,
  tooltipBuilder = (children2) => children2,
  ...rest
}) {
  const overflowContainer = useRef(null);
  const isTruncated = useIsTextTruncated(overflowContainer);
  if (typeof children !== "string" || children.length < endLetters) {
    return className ? /* @__PURE__ */ jsx("span", { className, id, ...rest, children }) : /* @__PURE__ */ jsx(Fragment, { children });
  }
  return /* @__PURE__ */ jsx(
    Tooltip,
    {
      disabled: !isTruncated,
      tooltip: tooltipBuilder(children),
      type: "dropdown",
      withArrow: false,
      placement,
      offset,
      usePortal,
      id,
      children: /* @__PURE__ */ jsx("div", { ref: overflowContainer, className: clsx("truncate", className), ...rest, children })
    }
  );
}

export { Truncate };
